/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-07-24 15:15:37
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-12 15:43:41
 */

import moment from 'moment'
import { DateTimeFormatSimpleOnlyOne } from './datetime'

export function printBodyBDHBB(data: any) {
  const tenantName = data?.tenantName
  const title = data?.title
  const detail = data?.detail
  const datas = data?.dataList

  const noHJPage = data?.dataList?.filter(
    (v: any) => v?.xianzhonglxmc != '合计' && v?.xianzhonglxmc != '总合计'
  )
  const HJPage = data?.dataList?.filter((v: any) => v?.xianzhonglxmc == '合计')

  let sjDatas = ''

  // 使用 table 结构
  sjDatas +=
    '<table style="width:98%;border-collapse:collapse;font-size:8px;margin:0 10px">'
  // 表头
  sjDatas += `
    <tr style="border-top:1px solid #000;font-weight:600;">
      <th style="border:1px solid #000;">业务类型</th>
      <th style="border:1px solid #000;">险种</th>
      <th style="border:1px solid #000;">类别</th>
      <th style="border:1px solid #000;">人次</th>
      <th style="border:1px solid #000;">人头</th>
      <th style="border:1px solid #000;">人次人头比</th>
      <th style="border:1px solid #000;">总额</th>
      <th style="border:1px solid #000;">现金</th>
      <th style="border:1px solid #000;">个账</th>
      <th style="border:1px solid #000;">当年账户支出</th>
      <th style="border:1px solid #000;">历年账户支出</th>
      <th style="border:1px solid #000;">账户共济支出</th>
      <th style="border:1px solid #000;">基金支付总额</th>
      <th style="border:1px solid #000;">统筹基金</th>
      <th style="border:1px solid #000;">列支</th>
      <th style="border:1px solid #000;">公务员医疗补助</th>
      <th style="border:1px solid #000;">次均</th>
      <th style="border:1px solid #000;">人均</th>
      <th style="border:1px solid #000;">自理</th>
      <th style="border:1px solid #000;">全自费金额</th>
      <th style="border:1px solid #000;">超限金额</th>
      <th style="border:1px solid #000;">核拨</th>
    </tr>
  `

  // 处理数据行
  for (let i = 0; i < datas?.length; i++) {
    const item = datas[i]
    const isTotal = item?.xianzhonglxmc == '合计'
    const isGrandTotal = item?.xianzhonglxmc == '总合计'

    sjDatas += '<tr style="font-weight:300;">'

    // 业务类型列
    if (isGrandTotal) {
      sjDatas += `
        <td style="border:1px solid #000;text-align:center;" rowspan="${1}" colspan="${3}">
          ${item.xianzhonglxmc}
        </td>
      `
    } else if (isTotal) {
      if (i == 0) {
        sjDatas += `
          <td style="border:1px solid #000;text-align:center;" rowspan="${
            noHJPage?.length
          }"  colspan="${2}">
          ${item.xianzhonglxmc}
          </td>
        `
      } else if (i == noHJPage?.length) {
        sjDatas += `
          <td style="border:1px solid #000;text-align:center;" rowspan="${
            HJPage?.length
          }"  colspan="${2}">
          ${item.xianzhonglxmc}
          </td>
        `
      }
    } else {
      if (i == 0) {
        sjDatas += `
          <td style="border:1px solid #000;text-align:center;" rowspan="${
            noHJPage?.length
          }" colspan="${1}">
           门诊(含特慢病)
          </td>
        `
      } else if (i == noHJPage?.length) {
        sjDatas += `
          <td style="border:1px solid #000;text-align:center;" rowspan="${
            HJPage?.length
          }" colspan="${1}">
          门诊(含特慢病)
          </td>
        `
      }

      // 险种列
      if (i === 0 || datas[i - 1]?.xianzhonglxmc !== item.xianzhonglxmc) {
        const sameGroup = datas.filter(
          (v: any) =>
            v.xianzhonglxmc === item.xianzhonglxmc &&
            v.yiliaolbmc !== '合计' &&
            v.yiliaolbmc !== '总合计'
        )
        sjDatas += `
          <td style="border:1px solid #000;text-align:center;" rowspan="${sameGroup.length}">
            ${item.xianzhonglxmc}
          </td>
        `
      }
    }

    // 类别列
    if (!isGrandTotal) {
      sjDatas += `
        <td style="border:1px solid #000;text-align:center;">
          ${item.yiliaolbmc || '-'}
        </td>
      `
    }

    // 数值列
    sjDatas += `
      <td style="border:1px solid #000;text-align:center;">${
        item?.personTime ? item?.personTime : 0
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.headCount ? item?.headCount : 0
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        isNaN(item?.personHeadScale)
          ? '-'
          : Number(item?.personHeadScale).toFixed(2)
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.totalAmount ? item?.totalAmount?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.cashAmount ? item?.cashAmount?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.gerenzhzc ? item?.gerenzhzc?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.dangnianzhzc ? item?.dangnianzhzc?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.linianzhzc ? item?.linianzhzc?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.gerenzhgjzfje ? item?.gerenzhgjzfje?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.jijinzfze ? item?.jijinzfze?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.jibenylbxtcjjzc ? item?.jibenylbxtcjjzc?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.includedMedicalExpenses
          ? item?.includedMedicalExpenses?.toFixed(2)
          : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.gongwuyylbzzjzc ? item?.gongwuyylbzzjzc?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        isNaN(item?.totalAmountPer)
          ? '-'
          : Number(item?.totalAmountPer).toFixed(2)
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        isNaN(item?.totalAmountPerson)
          ? '-'
          : Number(item?.totalAmountPerson).toFixed(2)
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.xianxingzfje ? item?.xianxingzfje?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.quanzifje ? item?.quanzifje?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.chaoxianjzffy ? item?.chaoxianjzffy?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.reimbursementAmount
          ? item?.reimbursementAmount?.toFixed(2)
          : '0.00'
      }</td>
    `

    sjDatas += '</tr>'
  }

  sjDatas += '</table>'

  // 底部签名部分
  const content = `
    <h6 style="text-align:center;margin-bottom:5px;">${tenantName}</h6>
    <div style="text-align:center;">
      <h5 style="display:inline-block;width:30%;">${title}</h5>
    </div>
    <div style="text-align:left;font-weight:600;font-size:10px;padding:0px 20px 8px 20px">
      <div style="display:inline-block;width:33%;">定点医药机构编码: <span style="font-weight:300;">${
        detail?.countryHospitalNb
      }</span></div>
      <div style="display:inline-block;width:33%;">定点医药机构名称(盖章): <span style="font-weight:300;">${tenantName}</span></div>
      <div style="display:inline-block;width:33%;">结算起止时间：<span style="font-weight:300;">${
        detail?.startTime
      }至${detail?.endTime}</span></div>
    </div>
    ${sjDatas}
    <div style="display:flex;font-weight:600;font-size:10px;padding:5px 20px 0px 20px">
      <div style="width:33%;">单位负责人: </div>
      <div style="width:33%;">仓管员: </div> 
      <div style="width:33%;">财&emsp;&emsp;务: </div>
    </div>
    <div style="display:flex;font-weight:600;font-size:10px;padding:5px 20px 0px 20px">
    <div style="width:33%;">审&emsp;&emsp;&emsp;核: </div>
    <div style="width:33%;">制单人: </div> 
    <div style="width:33%;">制单日期: ${moment().format(
      DateTimeFormatSimpleOnlyOne
    )}</div>
  </div>
  `

  return content
}

export function printBodyYDHBB(data: any) {
  const tenantName = data?.tenantName
  const title = data?.title
  const detail = data?.detail
  const datas = data?.dataList
  const SBDataList = data?.SBPageList
  let sjDatas = ''

  // 申报
  let SBDatas = ''
  // 使用 table 结构
  sjDatas +=
    '<table style="width:98%;border-collapse:collapse;font-size:8px;margin:0 10px">'
  // 表头
  sjDatas += `
    <tr style="border-top:1px solid #000;font-weight:600;">
      <th style="border:1px solid #000;">类别</th>
      <th style="border:1px solid #000;">人次</th>
      <th style="border:1px solid #000;">总额</th>
      <th style="border:1px solid #000;">个人现金</th>
      <th style="border:1px solid #000;">核拨</th>
    </tr>
  `

  // 处理数据行
  for (let i = 0; i < datas?.length; i++) {
    const item = datas[i]
    sjDatas += '<tr style="font-weight:300;">'

    // 数值列
    sjDatas += `
      <td style="border:1px solid #000;text-align:center;">${
        item?.xianzhonglxmc ? item?.xianzhonglxmc : '-'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.personTime ? item?.personTime : '-'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.totalAmount ? item?.totalAmount?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.cashAmount ? item?.cashAmount?.toFixed(2) : '0.00'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.reimbursementAmount
          ? item?.reimbursementAmount?.toFixed(2)
          : '0.00'
      }</td>
    `

    sjDatas += '</tr>'
  }

  sjDatas += '</table>'

  SBDatas +=
    '<table style="width:98%;border-collapse:collapse;font-size:8px;margin:0 10px">'
  // 表头
  SBDatas += `
<tr style="border-top:1px solid #000;font-weight:600;">
  <th style="border:1px solid #000;">申报金额</th>
  <th style="border:1px solid #000;">费用总额</th>
  <th style="border:1px solid #000;">职工基金总额</th>
  <th style="border:1px solid #000;">居民基金总额</th>
  <th style="border:1px solid #000;">离休基金总额</th>
</tr>
`
  // 处理数据行
  for (let i = 0; i < SBDataList?.length; i++) {
    const item = SBDataList[i]
    SBDatas += '<tr style="font-weight:300;">'

    // 数值列
    SBDatas += `
      <td style="border:1px solid #000;text-align:center;">${
        item?.totalAmountDeclared ? item?.totalAmountDeclared : '-'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.totalAmount ? item?.totalAmount : '-'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.total310FundsAmount ? item?.total310FundsAmount : '-'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.total390FundsAmount ? item?.total390FundsAmount : '-'
      }</td>
      <td style="border:1px solid #000;text-align:center;">${
        item?.total340FundsAmount ? item?.total340FundsAmount : '-'
      }</td>
    `

    SBDatas += '</tr>'
  }

  SBDatas += '</table>'

  // 底部签名部分
  const content = `
    <h6 style="text-align:center;margin-bottom:5px;">${tenantName}</h6>
    <div style="text-align:center;">
      <h5 style="display:inline-block;width:33%;">${title}</h5>
    </div>
    <div style="text-align:left;font-weight:600;font-size:10px;padding:0px 20px 8px 20px">
      <div style="display:inline-block;width:33%;">定点医药机构编码: <span style="font-weight:300;">${
        detail?.countryHospitalNb
      }</span></div>
      <div style="display:inline-block;width:33%;">定点医药机构名称(盖章): <span style="font-weight:300;">${tenantName}</span></div>
      <div style="display:inline-block;width:33%;">结算起止时间：<span style="font-weight:300;">${
        detail?.startTime
      }至${detail?.endTime}</span></div>
    </div>
    ${sjDatas}
    <div style="text-align:left;font-weight:600;font-size:12px;padding:6px 20px 8px 20px">
      <div style="display:inline-block;width:100%;"><span style="font-weight:300;">申报信息 </span></div>
    </div>
    ${SBDatas}
    <div style="display:flex;font-weight:600;font-size:10px;padding:5px 20px 0px 20px">
      <div style="width:33%;">单位负责人: </div>
      <div style="width:33%;">仓管员: </div> 
      <div style="width:33%;">财&emsp;&emsp;务: </div>
    </div>
    <div style="display:flex;font-weight:600;font-size:10px;padding:5px 20px 0px 20px">
    <div style="width:33%;">审&emsp;&emsp;&emsp;核: </div>
    <div style="width:33%;">制单人: </div> 
    <div style="width:33%;">制单日期: ${moment().format(
      DateTimeFormatSimpleOnlyOne
    )}</div>
  </div>
  `

  return content
}
